"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDatetimeInputControl = void 0;
const react_1 = __importStar(require("react"));
const controls_1 = require("../..");
const DatetimeInputControl_1 = require("../components/DatetimeInputControl/DatetimeInputControl");
const parseDate_1 = require("../helpers/parseDate");
const helpers_1 = require("../../../helpers");
exports.DefaultDatetimeInputControl = react_1.default.memo(function DefaultDatetimeInputControl(_a) {
    var { className, control, error, placeholder, disabled, size, active, actions, opened, focused, value, startDatetime, endDatetime, hasEnterKeyStopPropagation = true, testId, valueFormatter, hasKeyboardEnter, onChange, onValueError, withTime, withSeconds, is12Hours, texts, style } = _a, rest = __rest(_a, ["className", "control", "error", "placeholder", "disabled", "size", "active", "actions", "opened", "focused", "value", "startDatetime", "endDatetime", "hasEnterKeyStopPropagation", "testId", "valueFormatter", "hasKeyboardEnter", "onChange", "onValueError", "withTime", "withSeconds", "is12Hours", "texts", "style"]);
    const inputValue = (0, react_1.useMemo)(() => {
        var _a;
        return (_a = valueFormatter === null || valueFormatter === void 0 ? void 0 : valueFormatter({
            value,
            withTime,
            withSeconds,
            is12Hours,
            texts
        })) !== null && _a !== void 0 ? _a : (0, controls_1.defaultDatetimeInputControlValueFormatter)({
            value,
            withTime,
            withSeconds,
            is12Hours,
            texts
        });
    }, [is12Hours, texts, value, valueFormatter, withSeconds, withTime]);
    const { getValue, setValue } = (0, helpers_1.useStateValue)(inputValue, [inputValue]);
    const [hasValidationError, setHasValidatorError] = (0, react_1.useState)(false);
    const onInputChange = (0, react_1.useCallback)((value) => {
        const date = (0, parseDate_1.parseDate)(value, withTime, is12Hours);
        setValue(value);
        if (value === '') {
            setHasValidatorError(false);
            onChange === null || onChange === void 0 ? void 0 : onChange(null);
            return;
        }
        if (!date) {
            setHasValidatorError(true);
            onValueError === null || onValueError === void 0 ? void 0 : onValueError(controls_1.DATETIME_INPUT_ERROR.parse);
            return;
        }
        if (date < startDatetime) {
            setHasValidatorError(true);
            onValueError === null || onValueError === void 0 ? void 0 : onValueError(controls_1.DATETIME_INPUT_ERROR.ltStart);
            return;
        }
        if (date > endDatetime) {
            setHasValidatorError(true);
            onValueError === null || onValueError === void 0 ? void 0 : onValueError(controls_1.DATETIME_INPUT_ERROR.gtEnd);
            return;
        }
        setHasValidatorError(false);
        onChange === null || onChange === void 0 ? void 0 : onChange(date);
    }, [endDatetime, is12Hours, onChange, onValueError, setValue, startDatetime, withTime]);
    const { ref: refControl, onFocus: onFocusControl, onBlur: onBlurControl, onClick: onClickControl, onMouseDown: onMouseDownControl, onMouseUp: onMouseUpControl, onMouseEnter: onMouseEnterControl, onMouseLeave: onMouseLeaveControl, onKeyDown: onKeyDownControl, onKeyUp: onKeyUpControl, onKeyPress: onKeyPressControl } = control;
    const changeHandler = (0, react_1.useCallback)((value) => {
        setValue(value);
        onInputChange(value);
    }, [onInputChange, setValue]);
    const blurHandler = (0, react_1.useCallback)((e) => {
        if (hasValidationError) {
            setValue(inputValue);
            onChange === null || onChange === void 0 ? void 0 : onChange(value || null);
        }
        onBlurControl === null || onBlurControl === void 0 ? void 0 : onBlurControl(e);
    }, [hasValidationError, inputValue, onBlurControl, onChange, setValue, value]);
    const readOnly = (0, react_1.useMemo)(() => (valueFormatter ? true : !hasKeyboardEnter), [hasKeyboardEnter, valueFormatter]);
    return (react_1.default.createElement(DatetimeInputControl_1.DatetimeInputControl, Object.assign({}, rest, { style: style, testId: testId, readOnly: readOnly, placeholder: placeholder, actions: actions, error: error, disabled: disabled, focused: focused, active: active, opened: opened, onChange: changeHandler, size: size, value: getValue(), hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, control: {
            ref: refControl,
            onFocus: onFocusControl,
            onBlur: blurHandler,
            onClick: onClickControl,
            onMouseDown: onMouseDownControl,
            onMouseUp: onMouseUpControl,
            onMouseEnter: onMouseEnterControl,
            onMouseLeave: onMouseLeaveControl,
            onKeyDown: onKeyDownControl,
            onKeyUp: onKeyUpControl,
            onKeyPress: onKeyPressControl
        }, className: className })));
});
//# sourceMappingURL=DefaultDatetimeInputControl.js.map